module.exports = __webpack_public_path__ + "static/media/tlaxcala-shield.7effcab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/tlaxcala-shield.png
// module id = 205
// module chunks = 0